import { Shark } from "shark-mvc";

import ViewBase from "../ViewBase";

import templateContent from "./set-client-solvency-status.html";

import clientSolvencyRequestManager from "../../controllers/clientSolvencyRequestManager";
import followUpComponent from "../../components/followUp/followUpComponent";
import mainNavComponent from "../../_shark_jaws/components/mainNavComponent";
import { siteInfoSheetManager } from "../../_shark_jaws/managers/siteInfoSheetManager";
import waitBoxComponent from "../../_shark_components/waitBox/waitBoxComponent";
import { clientManager } from "../../_shark_jaws/managers/clientManager";

class SetClientSolvencyStatusView extends ViewBase {
	constructor () {
		super("setClientSolvencyStatusView");
		this.setTemplate(templateContent);
	}

	async beforeLoad () {
		window.scrollTo(0, 0);

		followUpComponent.set("targetItem", null);
		this.set({
			__htmlTitle: "Richiesta solvibilità Cliente | IPM HUB",
		});

		const urlSearchParams = new URLSearchParams(document.location.search);

		if (urlSearchParams.has("sisg")) {
			const currSiteInfoSheetResult = await siteInfoSheetManager.getByGuid(urlSearchParams.get("sisg"));
			const currSiteInfoSheet = currSiteInfoSheetResult.data;

			Shark.set({
				currSiteInfoSheet,
			});
		}
		else if (urlSearchParams.has("clsrg")) {
			const currClientSolvencyRequestResult = await clientSolvencyRequestManager.getByGuid(urlSearchParams.get("clsrg"));
			const currClientSolvencyRequest = currClientSolvencyRequestResult.data;

			if (currClientSolvencyRequest) {
				const currClientResult = await clientManager.getByGuid(currClientSolvencyRequest.contactGuid);
				const currClient = currClientResult.data;
				
				Shark.set({
					currClient,
					currClientSolvencyRequest,
				});
			}
		}
	}

	beforeUnload () {
		clearTimeout(this.messageTimeoutId);
	}

	init () {
		this.addComponents([followUpComponent, mainNavComponent, waitBoxComponent]);

		Shark.set({
			actionResponseMessage: "",
			currSiteInfoSheet: null,
			currClientSolvencyRequest: null,
		});
	}

	async saveClientSolvencySettings () {
		const { currClientSolvencyRequest, currSiteInfoSheet } = Shark.get();

		if (currSiteInfoSheet) {
			waitBoxComponent.open();
			const saveResult = await siteInfoSheetManager.saveClientSolvencySettings(currSiteInfoSheet);
			console.log({saveResult});

			Shark.set({
				actionResponseMessage: "Salvataggio completato correttamente",
			});

			this.messageTimeoutId = setTimeout(() => {
				this.messageTimeoutId = null;

				Shark.set({
					actionResponseMessage: "",
				});
			}, 4000);

			waitBoxComponent.close();
		}
		else if (currClientSolvencyRequest) {
			waitBoxComponent.open();
			const saveResult = await clientSolvencyRequestManager.saveClientSolvencySettings(currClientSolvencyRequest);
			console.log({saveResult});

			Shark.set({
				actionResponseMessage: "Salvataggio completato correttamente",
			});

			this.messageTimeoutId = setTimeout(() => {
				this.messageTimeoutId = null;

				Shark.set({
					actionResponseMessage: "",
				});
			}, 4000);

			waitBoxComponent.close();
		}
	}

	saveClientSolvencySettingsBtn_clickHandler () {
		this.saveClientSolvencySettings();
	}
}

const setClientSolvencyStatusView = new SetClientSolvencyStatusView();

Shark.registerView(setClientSolvencyStatusView);

export default setClientSolvencyStatusView;
